/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Product } from '../models/Product';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductsService {
    /**
     * List all products
     * @param page Page number
     * @param limit Items per page
     * @param enabled is enabled
     * @returns any Successful operation
     * @throws ApiError
     */
    public static listProducts(
        page: number = 1,
        limit: number = 10,
        enabled: boolean = true,
    ): CancelablePromise<{
        items?: Array<Product>;
        total?: number;
        page?: number;
        limit?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products',
            query: {
                'page': page,
                'limit': limit,
                'enabled': enabled,
            },
        });
    }
    /**
     * Create a new product
     * @param requestBody
     * @returns Product Product created successfully
     * @throws ApiError
     */
    public static createProduct(
        requestBody: Product,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/products',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get product by ID
     * @param id
     * @returns Product Successful operation
     * @throws ApiError
     */
    public static getProduct(
        id: string,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/products/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
    /**
     * Update product
     * @param id
     * @param requestBody
     * @returns Product Product updated successfully
     * @throws ApiError
     */
    public static updateProduct(
        id: string,
        requestBody: Product,
    ): CancelablePromise<Product> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/products/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Product not found`,
            },
        });
    }
    /**
     * Delete product
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteProduct(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/products/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Product not found`,
            },
        });
    }
}
